<script>
	import { Card, CardBody, CardSubtitle, Col, Row } from "sveltestrap";

	import { Splide, SplideSlide } from "@splidejs/svelte-splide";
	import {
		imageLightbox,
		pendingIssueCarSection,
		currentCarSection,
	} from "../../../../../../store/store";
	import NoData from "../../../../../../components/NoDataPage/NoData.svelte";
	import { convert } from "../../../../../../services/helpers";
	//Lightbox for image
	import Lightbox from "../../../../../../components/Lightbox/Lightbox.svelte";
	import {
		VehicleCarSectionOptions,
		VehicleDamageTypeOptions,
	} from "src/utils/options";
	import { damageAreaOptions } from "../../../../../../utils/options";
	import CustomPaginate from "../../../../../../components/CustomPaginate/Pagination.svelte";

	export let data;
	export let options = [];
	export let selectCarSection;
	export let unique;

	let modalOpen = false;
	let imageShowingIndex = 0;

	const handleImgClick = (i, img_url) => {
		imageLightbox.set(img_url);
		imageShowingIndex = Number(i);
		modalOpen = true;
	};

	let searchParams = new URLSearchParams(window.location.search);
	let selectedIssue =
		searchParams.get("carSection") == null
			? $pendingIssueCarSection
			: searchParams.get("carSection");

	const splitSalesQuotation = (salesQuotation) => {
		return salesQuotation.split("\r\n");
	};
</script>

{#if !data}
	<NoData />
{:else}
	{#if modalOpen}
		<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
	{/if}
	<div>
		{#each damageAreaOptions as { name, value, label }, key}
			<label
				key={`option-${name}-${key + 1}`}
				class="customCheckbox-new ms-2"
			>
				<input
					type="radio"
					{name}
					{value}
					bind:group={selectedIssue}
					on:click={() => selectCarSection(key + 1, label)}
					class="d-none input"
				/>
				<span class="customCheckbox-content-new py-1 mb-2">
					{label}
				</span>
			</label>
		{/each}
	</div>
	{#if data.length == 0}
		<NoData />
	{:else}
		{#each data as { originalId, bookingId, carSection, damageType, imageUrls = [], originalSalesQuotation, approvedAt }}
			<Card class="mb-3">
				<CardBody>
					<Col xs={12} class="mt-4 px-2">
						<Col
							xs={12}
							class="d-flex justify-content-between px-2 "
						>
							<CardSubtitle>
								<b>Issue ID: {originalId}</b>
								{#if bookingId != ""}
									<div>Booking ID: {bookingId}</div>
								{:else}
									<div>Booking ID: -</div>
								{/if}
							</CardSubtitle>
						</Col>
						<br />
						<Row>
							<Col xs={8} class="my-2">
								<Col md={8} class="mt-4">
									<Row class="my-3">
										<Col><span>Damage Type</span></Col>
										<Col>
											{#each VehicleDamageTypeOptions as option}
												{#if damageType == option.value}
													{option.label}
												{/if}
											{/each}
										</Col>
									</Row>
									<Row class="my-3">
										<Col><span>Approved At</span></Col>
										<Col>{convert(approvedAt)}</Col>
									</Row>
									<Row class="my-3">
										<Col><span>Sales Quotation</span></Col>
										<Col>
											{#each splitSalesQuotation(originalSalesQuotation) as quotes}
												<b>
													{quotes}
												</b>
												<br />
											{/each}
										</Col>
									</Row>
								</Col>
							</Col>
							{#if modalOpen}
								<Lightbox
									on:click={() => (modalOpen = false)}
									{imageShowingIndex}
								/>
							{/if}
							<Col xs={4}>
								<Splide
									{options}
									aria-label="My Favorite Images"
								>
									{#each imageUrls as slide, index}
										<SplideSlide active={1}>
											<!-- svelte-ignore a11y-click-events-have-key-events -->
											<img
												src={slide}
												alt="alt"
												style="width: 100%; height:100%; object-fit: scale-down; "
												class="link"
												on:click={() =>
													handleImgClick(
														index,
														imageUrls
													)}
											/>
										</SplideSlide>
									{/each}
								</Splide>
							</Col>
						</Row>
					</Col>
				</CardBody>
			</Card>
		{/each}
		{#key unique}
			<CustomPaginate totalRecord={data?.length || 0} />
		{/key}
	{/if}
{/if}
